import React, { useEffect } from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import Slider from 'react-slick'; // Slick Carousel component
import { useContent } from '../../../../context/ContentContext';

const EventListDisplay = () => {
    const { events, loading, error } = useContent();

    useEffect(() => {
        console.log("Loaded events:", events); // Debugging: Check if events are loaded correctly
    }, [events]);

    if (loading) {
        return (
            <div>
                {[...Array(5)].map((_, index) => (
                    <Card key={index} sx={{ marginBottom: 2 }}>
                        <CardContent>
                            <Typography variant="body2" color="textSecondary">Loading...</Typography>
                        </CardContent>
                    </Card>
                ))}
            </div>
        );
    }

    if (error) {
        return <Typography variant="h6" color="error">{error}</Typography>;
    }

    if (!events || events.length === 0) {
        return <Typography variant="h6">No events available</Typography>;
    }

    // Slick Carousel settings
    const settings = {
        dots: true,
        infinite: true, // Allow infinite scroll
        speed: 500,
        slidesToShow: 1, // Number of slides to show at a time
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            },
        ],
    };

    return (
        <div style={{ overflow: 'hidden' }}> {/* Added overflow hidden here */}
            <Slider {...settings} style={{ position: 'relative' }}>
                {events.map((event, index) => (
                    <Card key={index} sx={{ marginBottom: 2 }}>
                        <CardContent>
                            <Typography
                                variant="h6"
                                sx={{
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    whiteSpace: 'normal', // Allow text to wrap to new lines
                                }}
                            >
                                {event.title}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    whiteSpace: 'normal', // Allow text to wrap to new lines
                                }}
                            >
                                {event.location}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    whiteSpace: 'normal', // Allow text to wrap to new lines
                                }}
                            >
                                {event.date}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="primary"
                                fontWeight="bold"
                                sx={{
                                    wordWrap: 'break-word',
                                    overflow: 'hidden',
                                    whiteSpace: 'normal', // Allow text to wrap to new lines
                                }}
                            >
                                {event.price}
                            </Typography>
                            <img
                                src={event.image}
                                alt={event.title}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    marginTop: '10px',
                                    borderRadius: '4px',
                                }}
                            />
                        </CardContent>
                    </Card>
                ))}
            </Slider>
        </div>
    );
};

export default EventListDisplay;
